"use client"

import * as React from "react"

import type { SearchEntryKind } from "@/features/search/model/search-palette-types"
import { useTranslations } from "@/i18n"

/**
 * Labels for kinds and wire statuses. A status the palette has no wording for is left out rather than shown raw:
 * a backend enum value is not user-facing text.
 */
export function useSearchLabels() {
  const t = useTranslations("search")

  return React.useMemo(() => {
    const optional = (key: string): string | null => {
      const label = t(key)
      return label === `search.${key}` ? null : label
    }
    return {
      kindLabel: (kind: SearchEntryKind) => t(`kinds.${kind}`),
      statusLabel: (status: string | null | undefined) => (status ? optional(`statuses.${status.toLowerCase()}`) : null),
      transactionKindLabel: (kind: string | null | undefined) =>
        kind ? optional(`transactionKinds.${kind.toLowerCase()}`) : null,
    }
  }, [t])
}
